import { createReducer } from "reduxsauce";

import importer from "common/importer";

const { INITIAL_STATE } = importer("Stores/PublicContent/InitialState", null);
const { PublicContentTypes } = importer("Stores/PublicContent/Actions", null);

const parsedMenuItems = (state, { res }) => ({
  ...state,
  parsedMenuItems: res,
});

const getLoyaltyMilestonesLoading = (state) => ({
  ...state,
  getLoyaltyMilestonesSuccess: null,
  getLoyaltyMilestonesLoading: true,
  getLoyaltyMilestonesFailure: null,
});
const getLoyaltyMilestonesSuccess = (state, { res }) => ({
  ...state,
  getLoyaltyMilestonesSuccess: res,
  getLoyaltyMilestonesLoading: false,
  getLoyaltyMilestonesFailure: null,
});
const getLoyaltyMilestonesFailure = (state, { error }) => ({
  ...state,
  getLoyaltyMilestonesLoading: false,
  getLoyaltyMilestonesFailure: error,
});
const setBlogsCategoryList = (state, { res }) => ({
  ...state,
  blogsCategoryList: res,
});

const getMessagesLoading = (state) => ({
  ...state,
  getMessagesLoading: true,
  getMessagesSuccess: null,
  getMessagesFailure: null,
});
const getMessagesSuccess = (state, { res }) => ({
  ...state,
  messages: res.messages,
  messagesFiltered: res.filtered,
  getMessagesLoading: false,
  getMessagesSuccess: res,
  getMessagesFailure: null,
});
const getMessagesFailure = (state, { error }) => ({
  ...state,
  getMessagesLoading: false,
  getMessagesSuccess: null,
  getMessagesFailure: error,
});

//

const getCentersLoading = (state) => ({
  ...state,
  getCentersLoading: true,
  getCentersSuccess: null,
  getCentersFailure: null,
});
const getCentersSuccess = (state, { res }) => ({
  ...state,
  Centers: res,
  getCentersLoading: false,
  getCentersSuccess: res,
  getCentersFailure: null,
});
const getCentersFailure = (state, { error }) => ({
  ...state,
  getCentersLoading: false,
  getCentersSuccess: null,
  getCentersFailure: error,
});

//

const getCentersForMobileLoading = (state) => ({
  ...state,
  getCentersForMobileLoading: true,
  getCentersForMobileSuccess: null,
  getCentersForMobileFailure: null,
});
const getCentersForMobileSuccess = (state, { res }) => ({
  ...state,
  Centers: res,
  getCentersForMobileLoading: false,
  getCentersForMobileSuccess: res,
  getCentersForMobileFailure: null,
});
const getCentersForMobileFailure = (state, { error }) => ({
  ...state,
  getCentersForMobileLoading: false,
  getCentersForMobileSuccess: null,
  getCentersForMobileFailure: error,
});

//

const getGendersLoading = (state, { error }) => ({
  ...state,
  getGendersLoading: true,
  getGendersSuccess: null,
  getGendersFailure: null,
});
const getGendersSuccess = (state, { res }) => ({
  ...state,
  Genders: res,
  getGendersLoading: false,
  getGendersSuccess: res,
  getGendersFailure: null,
});
const getGendersFailure = (state, { error }) => ({
  ...state,
  getGendersLoading: false,
  getGendersSuccess: null,
  getGendersFailure: error,
});

//

const bannerShow = (state) => ({
  ...state,
  BannerOpen: true,
  BannerLastUpdate: +new Date(),
});
const bannerClose = (state) => ({
  ...state,
  BannerMessage: null,
  BannerOpen: false,
  BannerLastUpdate: +new Date(),
});

//
const getCountriesLoading = (state) => ({
  ...state,
  getCountriesLoading: true,
  getCountriesSuccess: null,
  getCountriesFailure: null,
});

const getCountriesSuccess = (state, { res }) => ({
  ...state,
  Countries: res,
  getCountriesLoading: false,
  getCountriesSuccess: res,
  getCountriesFailure: null,
});

const getCountriesFailure = (state, { error }) => ({
  ...state,
  getCountriesLoading: false,
  getCountriesSuccess: null,
  getCountriesFailure: error,
});

const getAllStatesLoading = (state) => ({
  ...state,
  getAllStatesLoading: true,
  getAllStatesSuccess: null,
  getAllStatesFailure: null,
});

const getAllStatesSuccess = (state, { res }) => ({
  ...state,
  States: res,
  getAllStatesLoading: false,
  getAllStatesSuccess: res,
  getAllStatesFailure: null,
});

const getAllStatesFailure = (state, { error }) => ({
  ...state,
  getAllStatesLoading: false,
  getAllStatesSuccess: null,
  getAllStatesFailure: error,
});

//

const clearBannerMessage = (state) => ({
  ...state,
  BannerMessage: null,
});

const setBannerMessage = (state, { message }) => ({
  ...state,
  BannerOpen: true,
  BannerMessage: message,
  BannerLastUpdate: +new Date(),
});

const getLanguagesLoading = (state) => ({
  ...state,
  getLanguagesLoading: true,
  getLanguagesSuccess: null,
  getLanguagesFailure: null,
});
const getLanguagesSuccess = (state, { res }) => ({
  ...state,
  Languages: res,
  getLanguagesLoading: null,
  getLanguagesSuccess: res,
  getLanguagesFailure: null,
});
const getLanguagesFailure = (state, { error }) => ({
  ...state,
  getLanguagesLoading: null,
  getLanguagesSuccess: null,
  getLanguagesFailure: error,
});

const getPhoneTypesLoading = (state) => ({
  ...state,
  getPhoneTypesLoading: true,
  getPhoneTypesSuccess: null,
  getPhoneTypesFailure: null,
});
const getPhoneTypesSuccess = (state, { res }) => ({
  ...state,
  PhoneTypes: res,
  getPhoneTypesLoading: null,
  getPhoneTypesSuccess: res,
  getPhoneTypesFailure: null,
});
const getPhoneTypesFailure = (state, { error }) => ({
  ...state,
  getPhoneTypesLoading: null,
  getPhoneTypesSuccess: null,
  getPhoneTypesFailure: error,
});

const getEthnicityOptionsLoading = (state) => ({
  ...state,
  getEthnicityOptionsLoading: true,
  getEthnicityOptionsSuccess: null,
  getEthnicityOptionsFailure: null,
});
const getEthnicityOptionsSuccess = (state, { res }) => ({
  ...state,
  Ethnicity: res,
  getEthnicityOptionsLoading: null,
  getEthnicityOptionsSuccess: res,
  getEthnicityOptionsFailure: null,
});
const getEthnicityOptionsFailure = (state, { error }) => ({
  ...state,
  getEthnicityOptionsLoading: null,
  getEthnicityOptionsSuccess: null,
  getEthnicityOptionsFailure: error,
});

const getLoyaltyAchievementBadgesLoading = (state) => ({
  ...state,
  getLoyaltyAchievementBadgesLoading: true,
  getLoyaltyAchievementBadgesSuccess: null,
  getLoyaltyAchievementBadgesFailure: null,
});
const getLoyaltyAchievementBadgesSuccess = (state, { res }) => ({
  ...state,
  getLoyaltyAchievementBadgesLoading: false,
  getLoyaltyAchievementBadgesSuccess: res,
  getLoyaltyAchievementBadgesFailure: null,
});
const getLoyaltyAchievementBadgesFailure = (state, { error }) => ({
  ...state,
  getLoyaltyAchievementBadgesLoading: false,
  getLoyaltyAchievementBadgesSuccess: null,
  getLoyaltyAchievementBadgesFailure: error,
});

const drupalMenuFetchLoading = (state, { menuType }) => ({
  ...state,
  drupalMenuLoading: {
    ...state.drupalMenuLoading,
    [menuType]: true,
  },
  drupalMenuSuccess: {
    ...state.drupalMenuSuccess,
    [menuType]: null,
  },
  drupalMenuFailure: {
    ...state.drupalMenuFailure,
    [menuType]: null,
  },
});

const drupalMenuFetchSuccess = (state, { res, menuType }) => ({
  ...state,
  drupalMenuLoading: {
    ...state.drupalMenuLoading,
    [menuType]: false,
  },
  drupalMenuSuccess: {
    ...state.drupalMenuSuccess,
    [menuType]: res,
  },
  drupalMenuFailure: {
    ...state.drupalMenuFailure,
    [menuType]: null,
  },
});

const drupalMenuFetchFailure = (state, { error, menuType }) => ({
  ...state,
  drupalMenuLoading: {
    ...state.drupalMenuLoading,
    [menuType]: false,
  },
  drupalMenuSuccess: {
    ...state.drupalMenuSuccess,
    [menuType]: null,
  },
  drupalMenuFailure: {
    ...state.drupalMenuFailure,
    [menuType]: error,
  },
});

const getFormsPageLoading = (state, { formType }) => ({
  ...state,
  getFormsPageLoading: {
    ...state.getFormsPageLoading,
    [formType]: true,
  },
  getFormsPageSuccess: {
    ...state.getFormsPageSuccess,
    [formType]: null,
  },
  getFormsPageFailure: {
    ...state.getFormsPageFailure,
    [formType]: null,
  },
});

const getFormsPageSuccess = (state, { res, formType }) => ({
  ...state,
  getFormsPageLoading: {
    ...state.getFormsPageLoading,
    [formType]: false,
  },
  getFormsPageSuccess: {
    ...state.getFormsPageSuccess,
    [formType]: res,
  },
  getFormsPageFailure: {
    ...state.getFormsPageFailure,
    [formType]: null,
  },
});

const getFormsPageFailure = (state, { error, formType }) => ({
  ...state,
  getFormsPageLoading: {
    ...state.getFormsPageoading,
    [formType]: false,
  },
  getFormsPageSuccess: {
    ...state.getFormsPageSuccess,
    [formType]: null,
  },
  getFormsPageFailure: {
    ...state.getFormsPageFailure,
    [formType]: error,
  },
});

const getRegistrationPageLoading = (state, { formType }) => ({
  ...state,
  getRegistrationPageLoading: {
    ...state.getRegistrationPageLoading,
    [formType]: true,
  },
  getRegistrationPageSuccess: {
    ...state.getRegistrationPageSuccess,
    [formType]: null,
  },
  getRegistrationPageFailure: {
    ...state.getRegistrationPageFailure,
    [formType]: null,
  },
});

const getRegistrationPageSuccess = (state, { res, formType }) => ({
  ...state,
  getRegistrationPageLoading: {
    ...state.getRegistrationPageLoading,
    [formType]: false,
  },
  getRegistrationPageSuccess: {
    ...state.getRegistrationPageSuccess,
    [formType]: res,
  },
  getRegistrationPageFailure: {
    ...state.getRegistrationPageFailure,
    [formType]: null,
  },
});

const getRegistrationPageFailure = (state, { error, formType }) => ({
  ...state,
  getRegistrationPageLoading: {
    ...state.getRegistrationPageLoading,
    [formType]: false,
  },
  getRegistrationPageSuccess: {
    ...state.getRegistrationPageSuccess,
    [formType]: null,
  },
  getRegistrationPageFailure: {
    ...state.getRegistrationPageFailure,
    [formType]: error,
  },
});

const getdrupalHomepageLoading = (state) => ({
  ...state,
  getdrupalHomepageLoading: true,
  getdrupalHomepageSuccess: null,
  getdrupalHomepageFailure: null,
});
const getdrupalHomepageSuccess = (state, { res }) => ({
  ...state,
  getdrupalHomepageLoading: false,
  getdrupalHomepageSuccess: res,
  getdrupalHomepageFailure: null,
});
const getdrupalHomepageFailure = (state, { error }) => ({
  ...state,
  getdrupalHomepageLoading: false,
  getdrupalHomepageSuccess: null,
  getdrupalHomepageFailure: error,
});

const getCustomPageLoading = (state) => ({
  ...state,
  getCustomPageLoading: true,
  getCustomPageSuccess: null,
  getCustomPageFailure: null,
});
const getCustomPageSuccess = (state, { res }) => ({
  ...state,
  getCustomPageLoading: false,
  getCustomPageSuccess: res,
  getCustomPageFailure: null,
});
const getCustomPageFailure = (state, { error }) => ({
  ...state,
  getCustomPageLoading: false,
  getCustomPageSuccess: null,
  getCustomPageFailure: error,
});

const getPromotionalBannerLoading = (state) => ({
  ...state,
  getPromotionalBannerLoading: true,
  getPromotionalBannerSuccess: null,
  getPromotionalBannerFailure: null,
});
const getPromotionalBannerSuccess = (state, { res }) => ({
  ...state,
  getPromotionalBannerLoading: false,
  getPromotionalBannerSuccess: res,
  getPromotionalBannerFailure: null,
});
const getPromotionalBannerFailure = (state, { error }) => ({
  ...state,
  getPromotionalBannerLoading: false,
  getPromotionalBannerSuccess: null,
  getPromotionalBannerFailure: error,
});

const getBlogsPageLoading = (state) => ({
  ...state,
  getBlogsPageLoading: true,
  getBlogsPageSuccess: null,
  getBlogsPageFailure: null,
});
const getBlogsPageSuccess = (state, { res }) => {
  return {
    ...state,
    getBlogsPageLoading: false,
    getBlogsPageSuccess: res,
    getBlogsPageFailure: null,
  };
};
const getBlogsPageFailure = (state, { error }) => ({
  ...state,
  getBlogsPageLoading: false,
  getBlogsPageSuccess: null,
  getBlogsPageFailure: error,
});

const getLocationsPageLoading = (state) => ({
  ...state,
  getLocationsPageLoading: true,
  getLocationsPageSuccess: null,
  getLocationsPageFailure: null,
});
const getLocationsPageSuccess = (state, { res }) => ({
  ...state,
  getLocationsPageLoading: false,
  getLocationsPageSuccess: res,
  getLocationsPageFailure: null,
});
const getLocationsPageFailure = (state, { error }) => ({
  ...state,
  getLocationsPageLoading: false,
  getLocationsPageSuccess: null,
  getLocationsPageFailure: error,
});

const getCenterDetailsPageLoading = (state) => ({
  ...state,
  getCenterDetailsPageLoading: true,
  getCenterDetailsPageSuccess: null,
  getCenterDetailsPageFailure: null,
});
const getCenterDetailsPageSuccess = (state, { res }) => ({
  ...state,
  getCenterDetailsPageLoading: false,
  getCenterDetailsPageSuccess: res,
  getCenterDetailsPageFailure: null,
});
const getCenterDetailsPageFailure = (state, { error }) => ({
  ...state,
  getCenterDetailsPageLoading: false,
  getCenterDetailsPageSuccess: null,
  getCenterDetailsPageFailure: error,
});

const getPatientTestimonialsLoading = (state) => ({
  ...state,
  getPatientTestimonialsLoading: true,
  getPatientTestimonialsSuccess: null,
  getPatientTestimonialsFailure: null,
});

const getPatientTestimonialsSuccess = (state, { res }) => ({
  ...state,
  getPatientTestimonialsLoading: false,
  getPatientTestimonialsSuccess: res,
  getPatientTestimonialsFailure: null,
});
const getPatientTestimonialsFailure = (state, { error }) => ({
  ...state,
  getPatientTestimonialsLoading: false,
  getPatientTestimonialsSuccess: null,
  getPatientTestimonialsFailure: error,
});

const getDrupalNavigationLoading = (state) => ({
  ...state,
  getDrupalNavigationLoading: true,
  getDrupalNavigationSuccess: null,
  getDrupalNavigationFailure: null,
});
const getDrupalNavigationSuccess = (state, { res }) => ({
  ...state,
  getDrupalNavigationLoading: false,
  getDrupalNavigationSuccess: res,
  getDrupalNavigationFailure: null,
});
const getDrupalNavigationFailure = (state, { error }) => ({
  ...state,
  getDrupalNavigationLoading: false,
  getDrupalNavigationSuccess: null,
  getDrupalNavigationFailure: error,
});

const saveContactFormLoading = (state) => ({
  ...state,
  saveContactFormLoading: true,
  saveContactFormSuccess: null,
  saveContactFormFailure: null,
});
const saveContactFormSuccess = (state, { res }) => ({
  ...state,
  saveContactFormLoading: null,
  saveContactFormSuccess: res,
  saveContactFormFailure: null,
});
const saveContactFormFailure = (state, { error }) => ({
  ...state,
  saveContactFormLoading: null,
  saveContactFormSuccess: null,
  saveContactFormFailure: error,
});

const getRedeemPausedLoading = (state) => ({
  ...state,
  getRedeemPausedLoading: true,
  getRedeemPausedSuccess: null,
  getRedeemPausedFailure: null,
});
const getRedeemPausedSuccess = (state, { res }) => ({
  ...state,
  getRedeemPaused: res,
  getRedeemPausedLoading: false,
  getRedeemPausedSuccess: res,
  getRedeemPausedFailure: null,
});
const getRedeemPausedFailure = (state, { error }) => ({
  ...state,
  getRedeemPausedLoading: false,
  getRedeemPausedSuccess: null,
  getRedeemPausedFailure: error,
});

const getVendorRedeemPausedLoading = (state) => ({
  ...state,
  getVendorRedeemPausedLoading: true,
  getVendorRedeemPausedSuccess: null,
  getVendorRedeemPausedFailure: null,
});

const getVendorRedeemPausedSuccess = (state, { res }) => ({
  ...state,
  getVendorRedeemPaused: res,
  getVendorRedeemPausedLoading: false,
  getVendorRedeemPausedSuccess: res,
  getVendorRedeemPausedFailure: null,
});

const getVendorRedeemPausedFailure = (state, { error }) => ({
  ...state,
  getVendorRedeemPausedLoading: false,
  getVendorRedeemPausedSuccess: null,
  getVendorRedeemPausedFailure: error,
});

const getPostLoginPageLoading = (state) => ({
  ...state,
  getPostLoginPageLoading: true,
  getPostLoginPageSuccess: null,
  getPostLoginPageFailure: null,
});
const getPostLoginPageSuccess = (state, { res }) => ({
  ...state,
  getPostLoginPageLoading: false,
  getPostLoginPageSuccess: res,
  getPostLoginPageFailure: null,
});
const getPostLoginPageFailure = (state, { error }) => ({
  ...state,
  getPostLoginPageLoading: false,
  getPostLoginPageSuccess: null,
  getPostLoginPageFailure: error,
});

const getMobileScreenDataLoading = (state) => ({
  ...state,
  getMobileScreenDataLoading: true,
  getMobileScreenDataSuccess: null,
  getMobileScreenDataFailure: null,
});
const getMobileScreenDataSuccess = (state, { res }) => ({
  ...state,
  getMobileScreenDataLoading: false,
  getMobileScreenDataSuccess: res,
  getMobileScreenDataFailure: null,
});
const getMobileScreenDataFailure = (state, { error }) => ({
  ...state,
  getMobileScreenDataLoading: false,
  getMobileScreenDataSuccess: null,
  getMobileScreenDataFailure: error,
});

const getOnboardingScreenDataLoading = (state) => ({
  ...state,
  getOnboardingScreenDataLoading: true,
  getOnboardingScreenDataSuccess: null,
  getOnboardingScreenDataFailure: null,
});
const getOnboardingScreenDataSuccess = (state, { res }) => ({
  ...state,
  getOnboardingScreenDataLoading: false,
  getOnboardingScreenDataSuccess: res,
  getOnboardingScreenDataFailure: null,
});
const getOnboardingScreenDataFailure = (state, { error }) => ({
  ...state,
  getOnboardingScreenDataLoading: false,
  getOnboardingScreenDataSuccess: null,
  getOnboardingScreenDataFailure: error,
});

const closeMessage = (state, { message }) => {
  const tempClosedMessages = state.messagesClosed || [];
  tempClosedMessages.push(message);
  const unique = Array.from(new Set(tempClosedMessages));
  return {
    ...state,
    messagesClosed: unique,
  };
};

const getNewsPageLoading = (state) => ({
  ...state,
  getNewsPageLoading: true,
  getNewsPageSuccess: null,
  getNewsPageFailure: null,
});
const getNewsPageSuccess = (state, { res }) => {
  return {
    ...state,
    getNewsPageLoading: false,
    getNewsPageSuccess: res,
    getNewsPageFailure: null,
  };
};
const getNewsPageFailure = (state, { error }) => ({
  ...state,
  getNewsPageLoading: false,
  getNewsPageSuccess: null,
  getNewsPageFailure: error,
});

export const reducer = createReducer(INITIAL_STATE, {
  [PublicContentTypes.PARSED_MENU_ITEMS]: parsedMenuItems,

  [PublicContentTypes.GET_LOYALTY_MILESTONES_LOADING]:
    getLoyaltyMilestonesLoading,
  [PublicContentTypes.GET_LOYALTY_MILESTONES_SUCCESS]:
    getLoyaltyMilestonesSuccess,
  [PublicContentTypes.GET_LOYALTY_MILESTONES_FAILURE]:
    getLoyaltyMilestonesFailure,

  [PublicContentTypes.GET_MESSAGES_LOADING]: getMessagesLoading,
  [PublicContentTypes.GET_MESSAGES_SUCCESS]: getMessagesSuccess,
  [PublicContentTypes.GET_MESSAGES_FAILURE]: getMessagesFailure,

  [PublicContentTypes.GET_CENTERS_LOADING]: getCentersLoading,
  [PublicContentTypes.GET_CENTERS_SUCCESS]: getCentersSuccess,
  [PublicContentTypes.GET_CENTERS_FAILURE]: getCentersFailure,

  [PublicContentTypes.GET_CENTERS_FOR_MOBILE_LOADING]:
    getCentersForMobileLoading,
  [PublicContentTypes.GET_CENTERS_FOR_MOBILE_SUCCESS]:
    getCentersForMobileSuccess,
  [PublicContentTypes.GET_CENTERS_FOR_MOBILE_FAILURE]:
    getCentersForMobileFailure,

  [PublicContentTypes.GET_GENDERS_LOADING]: getGendersLoading,
  [PublicContentTypes.GET_GENDERS_SUCCESS]: getGendersSuccess,
  [PublicContentTypes.GET_GENDERS_FAILURE]: getGendersFailure,

  [PublicContentTypes.BANNER_SHOW]: bannerShow,
  [PublicContentTypes.BANNER_CLOSE]: bannerClose,

  [PublicContentTypes.CLEAR_BANNER_MESSAGE]: clearBannerMessage,
  [PublicContentTypes.SET_BANNER_MESSAGE]: setBannerMessage,
  [PublicContentTypes.CLOSE_MESSAGE]: closeMessage,

  [PublicContentTypes.GET_COUNTRIES_LOADING]: getCountriesLoading,
  [PublicContentTypes.GET_COUNTRIES_SUCCESS]: getCountriesSuccess,
  [PublicContentTypes.GET_COUNTRIES_FAILURE]: getCountriesFailure,

  [PublicContentTypes.GET_ALL_STATES_LOADING]: getAllStatesLoading,
  [PublicContentTypes.GET_ALL_STATES_SUCCESS]: getAllStatesSuccess,
  [PublicContentTypes.GET_ALL_STATES_FAILURE]: getAllStatesFailure,

  [PublicContentTypes.GET_LANGUAGES_LOADING]: getLanguagesLoading,
  [PublicContentTypes.GET_LANGUAGES_SUCCESS]: getLanguagesSuccess,
  [PublicContentTypes.GET_LANGUAGES_FAILURE]: getLanguagesFailure,

  [PublicContentTypes.GET_PHONE_TYPES_LOADING]: getPhoneTypesLoading,
  [PublicContentTypes.GET_PHONE_TYPES_SUCCESS]: getPhoneTypesSuccess,
  [PublicContentTypes.GET_PHONE_TYPES_FAILURE]: getPhoneTypesFailure,

  [PublicContentTypes.GET_ETHNICITY_OPTIONS_LOADING]:
    getEthnicityOptionsLoading,
  [PublicContentTypes.GET_ETHNICITY_OPTIONS_SUCCESS]:
    getEthnicityOptionsSuccess,
  [PublicContentTypes.GET_ETHNICITY_OPTIONS_FAILURE]:
    getEthnicityOptionsFailure,

  [PublicContentTypes.SAVE_CONTACT_FORM_LOADING]: saveContactFormLoading,
  [PublicContentTypes.SAVE_CONTACT_FORM_SUCCESS]: saveContactFormSuccess,
  [PublicContentTypes.SAVE_CONTACT_FORM_FAILURE]: saveContactFormFailure,

  [PublicContentTypes.GET_LOYALTY_ACHIEVEMENT_BADGES_LOADING]:
    getLoyaltyAchievementBadgesLoading,
  [PublicContentTypes.GET_LOYALTY_ACHIEVEMENT_BADGES_SUCCESS]:
    getLoyaltyAchievementBadgesSuccess,
  [PublicContentTypes.GET_LOYALTY_ACHIEVEMENT_BADGES_FAILURE]:
    getLoyaltyAchievementBadgesFailure,

  [PublicContentTypes.SET_BLOGS_CATEGORY_LIST]: setBlogsCategoryList,

  [PublicContentTypes.GET_REDEEM_PAUSED_LOADING]: getRedeemPausedLoading,
  [PublicContentTypes.GET_REDEEM_PAUSED_SUCCESS]: getRedeemPausedSuccess,
  [PublicContentTypes.GET_REDEEM_PAUSED_FAILURE]: getRedeemPausedFailure,

  [PublicContentTypes.GET_VENDOR_REDEEM_PAUSED_LOADING]:
    getVendorRedeemPausedLoading,
  [PublicContentTypes.GET_VENDOR_REDEEM_PAUSED_SUCCESS]:
    getVendorRedeemPausedSuccess,
  [PublicContentTypes.GET_VENDOR_REDEEM_PAUSED_FAILURE]:
    getVendorRedeemPausedFailure,

  [PublicContentTypes.DRUPAL_MENU_FETCH_LOADING]: drupalMenuFetchLoading,
  [PublicContentTypes.DRUPAL_MENU_FETCH_SUCCESS]: drupalMenuFetchSuccess,
  [PublicContentTypes.DRUPAL_MENU_FETCH_FAILURE]: drupalMenuFetchFailure,

  [PublicContentTypes.GET_DRUPAL_HOMEPAGE_LOADING]: getdrupalHomepageLoading,
  [PublicContentTypes.GET_DRUPAL_HOMEPAGE_SUCCESS]: getdrupalHomepageSuccess,
  [PublicContentTypes.GET_DRUPAL_HOMEPAGE_FAILURE]: getdrupalHomepageFailure,

  [PublicContentTypes.GET_DRUPAL_NAVIGATION_LOADING]:
    getDrupalNavigationLoading,
  [PublicContentTypes.GET_DRUPAL_NAVIGATION_SUCCESS]:
    getDrupalNavigationSuccess,
  [PublicContentTypes.GET_DRUPAL_NAVIGATION_FAILURE]:
    getDrupalNavigationFailure,

  [PublicContentTypes.GET_PATIENT_TESTIMONIALS_LOADING]:
    getPatientTestimonialsLoading,
  [PublicContentTypes.GET_PATIENT_TESTIMONIALS_SUCCESS]:
    getPatientTestimonialsSuccess,
  [PublicContentTypes.GET_PATIENT_TESTIMONIALS_FAILURE]:
    getPatientTestimonialsFailure,

  [PublicContentTypes.GET_FORMS_PAGE_LOADING]: getFormsPageLoading,
  [PublicContentTypes.GET_FORMS_PAGE_SUCCESS]: getFormsPageSuccess,
  [PublicContentTypes.GET_FORMS_PAGE_FAILURE]: getFormsPageFailure,

  [PublicContentTypes.GET_CUSTOM_PAGE_LOADING]: getCustomPageLoading,
  [PublicContentTypes.GET_CUSTOM_PAGE_SUCCESS]: getCustomPageSuccess,
  [PublicContentTypes.GET_CUSTOM_PAGE_FAILURE]: getCustomPageFailure,

  [PublicContentTypes.GET_PROMOTIONAL_BANNER_LOADING]:
    getPromotionalBannerLoading,
  [PublicContentTypes.GET_PROMOTIONAL_BANNER_SUCCESS]:
    getPromotionalBannerSuccess,
  [PublicContentTypes.GET_PROMOTIONAL_BANNER_FAILURE]:
    getPromotionalBannerFailure,

  [PublicContentTypes.GET_BLOGS_PAGE_LOADING]: getBlogsPageLoading,
  [PublicContentTypes.GET_BLOGS_PAGE_SUCCESS]: getBlogsPageSuccess,
  [PublicContentTypes.GET_BLOGS_PAGE_FAILURE]: getBlogsPageFailure,

  [PublicContentTypes.GET_REGISTRATION_PAGE_LOADING]:
    getRegistrationPageLoading,
  [PublicContentTypes.GET_REGISTRATION_PAGE_SUCCESS]:
    getRegistrationPageSuccess,
  [PublicContentTypes.GET_REGISTRATION_PAGE_FAILURE]:
    getRegistrationPageFailure,

  [PublicContentTypes.GET_LOCATIONS_PAGE_LOADING]: getLocationsPageLoading,
  [PublicContentTypes.GET_LOCATIONS_PAGE_SUCCESS]: getLocationsPageSuccess,
  [PublicContentTypes.GET_LOCATIONS_PAGE_FAILURE]: getLocationsPageFailure,

  [PublicContentTypes.GET_CENTER_DETAILS_PAGE_LOADING]:
    getCenterDetailsPageLoading,
  [PublicContentTypes.GET_CENTER_DETAILS_PAGE_SUCCESS]:
    getCenterDetailsPageSuccess,
  [PublicContentTypes.GET_CENTER_DETAILS_PAGE_FAILURE]:
    getCenterDetailsPageFailure,

  [PublicContentTypes.GET_POST_LOGIN_PAGE_LOADING]: getPostLoginPageLoading,
  [PublicContentTypes.GET_POST_LOGIN_PAGE_SUCCESS]: getPostLoginPageSuccess,
  [PublicContentTypes.GET_POST_LOGIN_PAGE_FAILURE]: getPostLoginPageFailure,

  [PublicContentTypes.GET_MOBILE_SCREEN_DATA_LOADING]:
    getMobileScreenDataLoading,
  [PublicContentTypes.GET_MOBILE_SCREEN_DATA_SUCCESS]:
    getMobileScreenDataSuccess,
  [PublicContentTypes.GET_MOBILE_SCREEN_DATA_FAILURE]:
    getMobileScreenDataFailure,

  [PublicContentTypes.GET_ONBOARDING_SCREEN_DATA_LOADING]:
    getOnboardingScreenDataLoading,
  [PublicContentTypes.GET_ONBOARDING_SCREEN_DATA_SUCCESS]:
    getOnboardingScreenDataSuccess,
  [PublicContentTypes.GET_ONBOARDING_SCREEN_DATA_FAILURE]:
    getOnboardingScreenDataFailure,

  [PublicContentTypes.GET_NEWS_PAGE_LOADING]: getNewsPageLoading,
  [PublicContentTypes.GET_NEWS_PAGE_SUCCESS]: getNewsPageSuccess,
  [PublicContentTypes.GET_NEWS_PAGE_FAILURE]: getNewsPageFailure,
});
